import axios from "axios";
import * as actionType from "../../../constant/actionType";

export const GetSavedCards = (params) => async () => {
  try {
    const storedData = JSON.parse(localStorage.getItem("LoginUserData"));
    const response = await axios({
      method: "get",
      headers: {
        Authorization: `Bearer ${localStorage.getItem("conserve_authtoken")}`,
        organisationid: storedData?.organisation_id,
      },
      url: `${actionType.environment_url}/api/provider/billing/cards`,
      params,
    });
    return response.data;
  } catch (error) {
    return { success: false, message: error?.response?.data?.message || error.message };
  }
};


